var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41.7778,
    height: 41.7778,
    rx: 20,
    fill: "#6EE796"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.35181 20.889C4.35181 13.0933 4.35181 9.19552 6.77359 6.77372C9.1954 4.35193 13.0932 4.35193 20.8888 4.35193C28.6844 4.35193 32.5823 4.35193 35.0042 6.77372C37.4259 9.19552 37.4259 13.0933 37.4259 20.889C37.4259 28.6845 37.4259 32.5824 35.0042 35.0043C32.5823 37.426 28.6844 37.426 20.8888 37.426C13.0932 37.426 9.1954 37.426 6.77359 35.0043C4.35181 32.5824 4.35181 28.6845 4.35181 20.889Z",
    stroke: "black",
    strokeWidth: 2.61111,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7222 20.889C28.7222 25.2153 25.2151 28.7223 20.8888 28.7223C16.5626 28.7223 13.0555 25.2153 13.0555 20.889C13.0555 16.5628 16.5626 13.0557 20.8888 13.0557C25.2151 13.0557 28.7222 16.5628 28.7222 20.889Z",
    stroke: "black",
    strokeWidth: 2.61111
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4764 11.3148H30.4608",
    stroke: "black",
    strokeWidth: 3.48148,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.afdd8cb99b1e25752353d44d4b21037e.svg";
export { ForwardRef as ReactComponent };